/**
 * Internal dependencies.
 */
import edit from './edit';
// import save from './save';
import metadata from './block.json';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category } = metadata;

const settings = {
	title: __( 'Count Down' ),
	description: __( 'Create beautiful count down section.' ),
	icon: <Icon icon="clock" />,
	keywords: [
		'gutenify',
		__( 'count down' ),
		__( 'counter' ),
	],
	example: {
		attributes: {
		},
	},
	attributes: {
		blockClientId: {
			type: 'string',
			default: '',
		},
		blockAdvanceOptions: {
			type: 'object',
			default: {
				padding: {
					desktop: {
						top: '10px',
						bottom: '10px',
						right: '10px',
						left: '10px',
					},
				},
			},
		},
		isSaved: {
			type: 'boolean',
			default: false,
		},
		dateTime: {
			type: 'string',
			default: new Date(),
		},
		showDays: {
			type: 'boolean',
			default: true,
		},
		showHour: {
			type: 'boolean',
			default: true,
		},
		showMinute: {
			type: 'boolean',
			default: true,
		},
		showSecond: {
			type: 'boolean',
			default: true,
		},
		showLabel: {
			type: 'boolean',
			default: true,
		},
		daysLabel: {
			type: 'string',
			default: 'Days',
		},
		hoursLabel: {
			type: 'string',
			default: 'Hours',
		},
		minutesLabel: {
			type: 'string',
			default: 'Minutes',
		},
		secondsLabel: {
			type: 'string',
			default: 'Seconds',
		},
		expireActions: {
			type: 'array',
			default: [],
		},
		expireMessage: {
			type: 'string',
		},
		expireURL: {
			type: 'string',
		},
	},
	edit,
	save: () => {},
	supports: {
		html: false,
	},
};

export { name, category, settings };
